import { useMutation } from "react-query";
import { AreaComumDisponibilidadeResponse } from "../typings";
import http from "infra/http";

function useSaveDisponibilidadeAreaComum(
  tenantId: string,
  areaComumId: string
) {
  return useMutation(
    (data: AreaComumDisponibilidadeResponse) => {
      return http.post(
        `/v1/tenants/${tenantId}/area-comum/${areaComumId}/disponibilidade`,
        data
      );
    },
    { retry: false }
  );
}

export default useSaveDisponibilidadeAreaComum;
